/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEnvContext, useWebStoreContext } from "contexts";
import { useEffect } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useAppDispatch } from "../../../hooks/useAppDispatch";
import { setSelectedDealIndex } from "redux/slices";
import { offersApi } from "redux/apis";
import {
	IShopPurchaseOfferMultiItem,
	IShopPurchaseOfferSingleItem
} from "contexts/WebStoreProvider/types";
import { FeaturesFlags } from "helpers";
import { sortByPriority } from "utils/sort";

enum FeatureParams {
	focus = "focus"
}

export const useRebateFocus = () => {
	const [searchParams] = useSearchParams();
	const dispatch = useAppDispatch();
	const navigate = useNavigate();
	const { pathname } = useLocation();
	const { authToken, openLoginToContinueDialog } = useWebStoreContext();
	const isAutoLogin = searchParams.has("loginType");
	const rebateOffer = searchParams.get(FeatureParams.focus) === "rebate";
	const { isFeatureFlagEnabled } = useEnvContext();

	const {
		data: featuredDealsData
	}: { data?: { offers?: IShopPurchaseOfferMultiItem[] } } =
		offersApi.endpoints.getOffers.useQueryState({
			offerType: "featured",
			isAuthenticated: !!authToken?.value
		});

	const offerIndex = sortByPriority(featuredDealsData?.offers).findIndex(
		(o) => o?.rebateConfig?.id
	);

	useEffect(() => {
		if (!isFeatureFlagEnabled(FeaturesFlags.REBATE)) {
			return;
		}

		if (rebateOffer) {
			if (isAutoLogin || offerIndex === -1) {
				return;
			}

			if (!authToken?.value) {
				openLoginToContinueDialog();
				return;
			}

			// Go to the featured deals
			dispatch(setSelectedDealIndex(offerIndex));

			searchParams.delete(FeatureParams.focus);

			navigate(
				{
					pathname,
					search: searchParams.toString()
				},
				{ replace: true }
			);
		}
	}, [
		authToken?.value,
		rebateOffer,
		isAutoLogin,
		featuredDealsData,
		offerIndex
	]);
};
